<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-80 md-medium-size-100">
      <SearchTable
        ref="table"
        :header="{
          title: 'Korisnici',
          icon: 'group',
          class: 'md-card-header-brand',
        }"
        :queriedData="users"
        :metaData="metaDataUsers"
        :getItems="getUsers"
        :params="paramsUsers"
        :sortBy="'id'"
      >
        <md-card-content class="md-layout" slot="header">
          <md-button
            class="ml-auto md-just-icon md-round add-user-button"
            v-if="!showAddUserForm"
            @click="showAddUserForm = !showAddUserForm"
          >
            <md-icon> person_add </md-icon>
          </md-button>
          <ValidationObserver v-slot="{ invalid }" slim v-else>
            <div
              class="md-layout md-layout-item ml-auto md-size-50 md-large-size-70 md-medium-size-100"
            >
              <ValidationProviderExtended
                name="Email"
                className="md-form-group md-layout-item md-size-40 md-large-size-70 md-medium-size-100"
                rules="required|email"
              >
                <md-icon> alternate_email </md-icon>
                <label> Email </label>

                <md-input v-model="newUser.email" type="text"> </md-input>
              </ValidationProviderExtended>

              <ValidationProviderExtended
                name="Korisnička grupa"
                className="md-layout-item md-size-40 md-large-size-70 md-medium-size-100"
                rules="required"
              >
                <label>Korisnička grupa</label>
                <md-select v-model="newUser.groupId">
                  <md-option
                    v-for="(group, index) in groups"
                    :key="index"
                    :value="group.id"
                    >{{ group.name }}</md-option
                  >
                </md-select>
              </ValidationProviderExtended>
              <md-button
                class="md-success md-layout-item md-size-15 md-large-size-30 md-medium-size-50"
                @click="registerUser"
                :disabled="invalid"
              >
                <md-icon> email </md-icon>
                Pozovi
              </md-button>
            </div>
          </ValidationObserver>
        </md-card-content>
      </SearchTable>
    </div>
    <div class="md-layout-item md-size-20 md-medium-size-50">
      <SearchTable
        ref="groupsTable"
        :header="{
          title: 'Grupe',
          icon: 'groups',
          class: 'md-card-header-brand',
        }"
        :queriedData="groups"
        :metaData="metaDataGroups"
        :getItems="getGroups"
        :params="paramsGroups"
        :sortBy="'id'"
        :openItem="getGroup"
        :newItem="createGroup"
        :forEachSelected="[
          {
            icon: 'delete',
            label: 'Briši',
            class: 'md-danger',
            function: deleteGroups,
          },
        ]"
      />
    </div>
    <div class="md-layout-item md-size-33 md-large-size-50">
      <UserGroup
        v-if="groupId !== null"
        :id="groupId"
        @saved-group="getGroups"
      />
    </div>
  </div>
</template>

<script>
// import clientData from './clients.js'
import SearchTable from '@/components/SearchTable.vue';
import UserGroup from '@/components/UserGroup.vue';
import services from '@/api/services';
import api from '@/api/api.js';
import Swal from 'sweetalert2';
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
import { cases } from '@/utils/helpers';
export default {
  components: {
    SearchTable,
    UserGroup,
    ValidationProviderExtended,
  },
  data() {
    return {
      paramsUsers: {
        id: null,
        firstName: '',
        lastName: '',
        email: '',
        group: '',
        position: '',
        contactNumber: '',
        status: ['ACTIVE', 'PENDING'],
      },
      newUser: {
        email: null,
        groupId: null,
      },
      users: [],
      selectedUser: null,
      metaDataUsers: null,
      paramsGroups: {
        id: null,
        name: '',
      },
      groups: [],
      groupId: null,
      metaDataGroups: null,
      showAddUserForm: false,
    };
  },
  methods: {
    getUsers(printTable = false) {
      const offset = this.metaDataUsers ? this.$refs.table.from : 0;
      const limit = this.metaDataUsers
        ? this.$refs.table.pagination.perPage
        : 75;
      const sortBy = this.metaDataUsers ? this.$refs.table.currentSort : null;
      const sortOrder = this.metaDataUsers
        ? this.$refs.table.currentSortOrder
        : null;

      return api
        .get(services.users.getUsers, {
          getUsers: true,
          params: this.paramsUsers,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.users = data.data;
          this.metaDataUsers = data.metaData;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    getGroups(printTable = false) {
      const offset = this.metaDataGroups ? this.$refs.groupsTable.from : 0;
      const limit = this.metaDataGroups
        ? this.$refs.groupsTable.pagination.perPage
        : 75;
      const sortBy = this.metaDataGroups
        ? this.$refs.groupsTable.currentSort
        : null;
      const sortOrder = this.metaDataGroups
        ? this.$refs.groupsTable.currentSortOrder
        : null;
      api
        .get(services.users.getGroups, {
          getGroups: true,
          params: this.paramsGroups,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.groups = data.data;
          this.metaDataGroups = data.metaData;
          // this.$refs.newUser.getGroups()
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    createGroup() {
      this.groupId = 0;
    },
    getGroup(value) {
      this.groupId = value.id;
    },
    deleteGroups(items) {
      const ids = items.map((el) => el.id);
      return Swal.fire({
        title: 'Briši grupe?',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'grupu',
          'grupe',
          'grupa',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((data) => {
        if (data.value) {
          api
            .post(services.users.deleteGroups, {
              deleteGroups: true,
              ids,
            })
            .then(() => {
              this.getGroups();
              this.$refs.groupsTable.removeChecked();
              this.$refs.newUser.getGroups();
            })
            .catch((error) => {
              this.alertError(error);
            });
        }
      });
    },
    registerUser() {
      api
        .post(services.users.createUser, {
          createUser: true,
          email: this.newUser.email,
          groupId: this.newUser.groupId,
        })
        .then(() => {
          this.newUser.email = null;
          this.newUser.groupId = null;
          this.showAddUserForm = false;
          this.getUsers();
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    hideClient() {
      this.selectedClient = null;
    },
    createUser() {
      this.selectedUser = {
        email: null,
        groupId: null,
      };
    },
  },
  mounted() {
    this.getUsers().then(() => {
      this.getGroups();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/md/_variables.scss';
.cursor-on-hover {
  cursor: pointer;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-out 0.5s;
}
.md-button.add-user-button:hover {
  background-color: $brand-info !important;
}

@keyframes bounce-in {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes bounce-out {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
